import * as api from "../api/index";
import * as endpoints from "../api/endpoints";

const actions = {
  getWorkApprovalWorks({ commit }, payload) {
    return api.fetch(endpoints.WORK_APPROVAL_WORKS, payload, commit);
  },
  getWorkApprovalProductions({ commit }, payload) {
    return api.fetch(endpoints.WORK_APPROVAL_PRODUCTIONS, payload, commit);
  },
  getWorkApprovalConsumDocumentGenerationStatuses({ commit }, payload) {
    return api.fetch(endpoints.WORK_APPROVAL_WORKS_DOCUMENT_GENERATION_STATUSES, payload, commit);
  },
  getWorkApprovalProductionDocumentGenerationStatuses({ commit }, payload) {
    return api.fetch(endpoints.WORK_APPROVAL_PRODUCTIONS_DOCUMENT_GENERATION_STATUSES, payload, commit);
  },
  approveWorks({ commit }, payload) {
    return api.post(endpoints.WORK_APPROVAL_WORKS_APPROVE, payload, commit);
  },
  revokeWorks({ commit }, payload) {
    return api.post(endpoints.WORK_APPROVAL_WORKS_REVOKE, payload, commit);
  },
  approveProductions({ commit }, payload) {
    return api.post(endpoints.WORK_APPROVAL_PRODUCTIONS_APPROVE, payload, commit);
  },
  revokeProductions({ commit }, payload) {
    return api.post(endpoints.WORK_APPROVAL_PRODUCTIONS_REVOKE, payload, commit);
  },
};

export default actions;
